import { Tag } from "~/ui/tag"

interface InvitationTagCellProps {
  tags: Array<{ id: string; name: string }>
}

export function InvitationTagCell({ tags }: InvitationTagCellProps) {
  return (
    <div className="flex w-full items-center">
      <div className="flex min-w-0 flex-1 flex-wrap items-center gap-1">
        {tags && tags.length > 0 ? (
          tags.map((tag: any) => (
            <Tag key={tag.id} className="group-hover:!bg-postal-purple group-hover:!text-white">
              {tag.name}
            </Tag>
          ))
        ) : (
          <span className="text-sm text-muted-foreground">-</span>
        )}
      </div>
    </div>
  )
}
